import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'liters'})
export class LitersPipe implements PipeTransform {
  transform(value: string | null): string | null {
    return (typeof value === 'undefined' || value === null) ? null : value + ' Liters';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/liters.pipe.ts